import mixpanel from 'mixpanel-browser';
mixpanel.init('7daf0a281a713e38bd2a36202bfc3721');


let tempUrl = `${window.location.href}`;
let env_check = tempUrl.search("app.askzoi.ai") > 0 ? 'production' : "dev";

let actions = {
  identify: (id) => {
    if (env_check === "production") mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check === "production") mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check === "production") mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check === "production") mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;